import { render, staticRenderFns } from "./app-company-comp.vue?vue&type=template&id=fd448272&scoped=true&"
import script from "./js/app-company-comp.js?vue&type=script&lang=js&"
export * from "./js/app-company-comp.js?vue&type=script&lang=js&"
import style0 from "./app-company-comp.vue?vue&type=style&index=0&id=fd448272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd448272",
  null
  
)

export default component.exports